import { FormControl, FormHelperText, RadioGroup } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import { type FieldValues, type FieldPath, useController } from "react-hook-form";
import type { ControlledInput } from "utils";

interface ControlledRadioGroupProps<T extends FieldValues, Name extends FieldPath<T>>
  extends ControlledInput<T, Name>, PropsWithChildren {
  disabled?: boolean;
  defaultHelperText?: string;
  fullWidth?: boolean;
  row?: boolean;
}

export function ControlledRadioGroup<T extends FieldValues, Name extends FieldPath<T>>({
  name,
  control,
  defaultValue,
  rules,
  disabled = false,
  defaultHelperText,
  fullWidth,
  row,
  children,
}: Readonly<ControlledRadioGroupProps<T, Name>>): ReactNode {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({ name, control, rules, defaultValue });

  return (
    <FormControl fullWidth={fullWidth} disabled={disabled}>
      <RadioGroup row={row} value={value} onChange={onChange}>
        {children}
      </RadioGroup>
      {(error?.message ?? defaultHelperText) != null && (
        <FormHelperText error={error != null}>{error?.message ?? defaultHelperText}</FormHelperText>
      )}
    </FormControl>
  );
}
